import { render } from "./ui-table-body-item.vue?vue&type=template&id=265baf88&scoped=true&ts=true"
import script from "./ui-table-body-item.vue?vue&type=script&lang=ts"
export * from "./ui-table-body-item.vue?vue&type=script&lang=ts"

import "./ui-table-body-item.vue?vue&type=style&index=0&id=265baf88&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265baf88"]])

export default __exports__